import { SlicePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { take } from 'rxjs/operators';
import { AlarmsListService } from '../../../services/alarms-list.service';
import { PermissionService } from '../../../services/permission.service';
import { ALARMS_NOTIFICATIONS } from '../../notifications-tab/notifications.constant';
import { AlarmLogCardComponent } from '../../shared/card/alarm-log-card/alarm-log-card.component';
import { WidgetLoaderComponent } from '../../shared/widget/widget-loader/widget-loader.component';

@Component({
  selector: 'widget-alarm-log',
  templateUrl: './widget-alarm-log.component.html',
  styleUrls: ['./widget-alarm-log.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslatePipe,
    MatIcon,
    MatTooltipModule,
    WidgetLoaderComponent,
    AlarmLogCardComponent,
    SlicePipe,
  ],
})
export class WidgetAlarmLogComponent implements OnInit, OnDestroy {
  private _alarmsListService = inject(AlarmsListService);
  private _router = inject(Router);
  public permissionService = inject(PermissionService);

  public alarmLogsData$ = this._alarmsListService.$unacknowledgedAlarm;
  private componentDestroy$ = new Subject<void>();

  ngOnInit(): void {
    if (this._alarmsListService.$alarmsLoaded()) {
      this.initComponent();
    } else {
      this._alarmsListService.alarmsLoadedEvent$.pipe(take(1)).subscribe(() => {
        this.initComponent();
      });
    }
  }

  private initComponent() {
    if (!this._alarmsListService.$unacknowledgedAlarm()) {
      this._alarmsListService.getUnacknowledgedAlarmLogs();
    }
  }

  ngOnDestroy() {
    this.componentDestroy$.next();
    this.componentDestroy$.complete();
  }

  goTo() {
    this._router.navigate([ALARMS_NOTIFICATIONS]);
  }
}
